<template>
    <span :class="['status-chip', 'is-' + type]">
        <i v-if="icon" :class="['fas', icon, 'mr-1']"></i>{{ label }}
    </span>
</template>

<script>
    // Small status pill. Colours follow the app theme (#336699 primary,
    // #e28b05 warning, #9b0d0d danger) so chips read the same as alerts.
    export default {
        name: "StatusChip",
        props: {
            label: {type: String, required: true},
            type: {type: String, default: 'neutral', validator: v => ['info', 'warning', 'danger', 'success', 'neutral'].includes(v)},
            icon: {type: String, default: null},
        }
    };
</script>

<style lang="scss" scoped>
    .status-chip {
        display: inline-flex;
        align-items: center;
        padding: 0.15rem 0.6rem;
        border-radius: 999px;
        font-size: 0.75rem;
        font-weight: 600;
        line-height: 1.4;
        white-space: nowrap;
        // Borderless, like the catalog's promo badge and the salary-lane
        // chips (Derek 2026-09-02)

        &.is-neutral {
            background: #f0f0f0;
            color: #5a5a5a;
        }

        &.is-info {
            background: #e8f0f8;
            color: #2a5580;
        }

        &.is-warning {
            background: #fdf1dc;
            color: #9a5d00;
        }

        &.is-danger {
            background: #f9e3e3;
            color: #8a0b0b;
        }

        &.is-success {
            background: #e3f3e8;
            color: #1f6b3a;
        }
    }
</style>
